import { ReadonlyRepositoryImpl, ReadonlyRepository, ApiService } from '@eceos/arch';
import { Injectable } from '@angular/core';
import { FiscalUnity } from './fiscal-unity';
@Injectable({ providedIn: 'root' })
export class FiscalUnitiesRepository extends ReadonlyRepositoryImpl<FiscalUnity, FiscalUnity>{
  constructor(api: ApiService) {
    super(api.root.path('fiscal/unities'), FiscalUnity, FiscalUnity);
  }
}
